const Form015SC = {
    stepName: {
        ImportantNotes: "重要提示",
        PersonalInfo: "教师资料",
        Nominate: "Nominated Rewards",
        Confirmation: "确认",
        ServiceRecord: "Service Record",
    },
    importantNotes: {
        p_title: "个人资料收集声明",
        p1_1: "教育局会利用本表格所载的个人资料，作以下其中一种或多种用途︰",
        p1_a: "办理与聘用有关的事宜；",
        p1_b: "处理发放薪金津贴，以及计算公积金的供款和赠款；",
        p1_c: "进行核数工作；",
        p1_d: "进行研究及统计资料，以便规划教育服务；",
        p1_e: "处理有关教育专业人员发展的事宜；",
        p1_f: "执行《教育条例》、《教育规例》及附属《补助/津贴学校公积金规则》(第279章)。",

        p2: "申请人必须在本表格上填写个人资料。申请人如不提供这些资料，申请的处理工作及结果或会受影响。",
        p3: "本表格所搜集的个人资料，或会向其他获授权的政府决策局/部门/机构披露作上述用途。",
        p4: "根据《个人资料(私隐)条例》，第18和22条及附表1保障资料第6原则的规定，你有权要求查阅及改正你的个人资料。要求查阅的权利，包括要求提供本表格所载个人资料的副本，但须缴付费用。",
        p5: "如欲查询有关本表格所搜集的个人资料，包括要求查阅及改正资料事宜，需以书面方式向教育局提出。",
    },
    errorMsg: {
        "E-0106": "AA000000(A)",
        "E-0101": "不允许使用中文数字",
        "E-0102": "请输入中文",
        college: "学院",
        notPublicUser: "此表格只能由公众用户提交",
    },
    titleOption: {
        Mr: "先生",
        Mrs: "女士",
        Miss: "小姐",
    },
    label: {
        ImportantNotesContent: {
            title: "个人资料收集声明",
            p_title: "收集个人资料的目的",
            p1_1: "你在本表格提供的个人资料，会供教育局用于以下一项或多项用途：",
            p1_a: "处理、核实及查证教师注册的申请；",
            p1_b: "就上文(a)项所述申请的处理、核实及查证，将个人资料与政府相关政策局／部门资料库进行核对；",
            p1_c: "将个人资料与教育局资料库进行核对，以核实／更新教育局的记录；",
            p1_d: "培训及发展，包括发出计划／活动邀请、处理发还课程费用申请、 评审提名、奖项和奖学金，以及监察达标进度；",
            p1_e: "处理及审核拨款／补助／津贴申请、发放拨款／补助／津贴，以及审计；",
            p1_f: "编制统计资料、研究及政府刊物；以及",
            p1_g: "执行规则及规例[包括《教育条例》(香港法例第279章)及其附属法例(例如《教育规例》、《补助学校公积金规则》、《津贴学校公积金规则》)、《资助则例》和《专上学院条例》(香港法例第320章) 及其附属法例]。",

            p2: "你必须按本表格的要求及于本局处理本表格的过程中提供个人资料。假如你没有提供该等个人资料，本局可能无法办理或继续处理申请。",

            p_title3: "可获转移资料者",
            p3_1: "你提供的个人资料会供教育局人员取阅。除此之外，本局亦可能会向下列各方或在下述情况转移或披露该等个人资料：",
            p3_a: "政府其他政策局及部门，包括香港警务处，以用于上文第1段所述的用途；",
            p3_b: "与本表格相关的学校，以用于上文第1段所述的用途；",
            p3_c: "你曾就披露个人资料给予订明同意；以及；",
            p3_d: "根据适用于香港的法例或法庭命令授权或规定披露个人资料。",

            p_title4: "查阅个人资料",
            p4: "你有权要求查阅及更正教育局所持有关于你的个人资料。如需查阅或更正个人资料，请以书面向教师注册小组提出(地址：九龙协调道3号工业贸易大楼2楼)。",
            // p5: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局提出。",
        },
        rewardOption: {
            Male: "男",
            Female: "女",
        },
        genderOption: {
            M: "男",
            F: "女",
        },
        regardingOption: {
            know: "知悉",
            notKnow: "不知悉",
        },
        fullTimePartTime: {
            fullTime: "全职",
            PartTime: "兼任",
        },
        unitOption: {
            perHour: "每小时",
            perWeek: "每周",
            perMonth: "每月",
        },
        partTimeHours: "兼任时数",
        photographs: "签名照片",
        certificate: "健康检查证明书",
        certificates: "学历证书或其他有关学历资格的证据",
        educated: "(g) 肄业的院校名称及日期：",
        termsConditions:
            "本人已阅读及明白《专上学院条例》（第 320 章）及《专上学院规例》（第 320 章，附属法例 A）。",
        iamStatement: "我理解申请人需要拥有「智方便+」账户才能处理申请。",
        college: "提交申请的学院",
        date: "日期",
        title: "称谓",
        notes1: "1. 现经校务委员会批准，本人申请将",
        notes2: "注册为本学院教师，有关该人的详情列于下文。",
        notes3: "2. 教师的资料：",
        teacherName: "姓名（中文）",
        englishName: "姓名（英文）",
        chineseName: "姓名（中文）",
        aliases: "别名",
        sex: "(d) 性别",
        dateBirth: "(e) 出生日期",
        placeBirth: "出生地点",
        university: "学校或大学",
        fromMonth: "由年／月",
        toMonth: "至年／月",
        educational: "学历资格（证书、文凭、学位）",
        detailsOccupation: "(i) 离开学校、学院或大学后曾从事教学以外的职业细节",
        teachingExp: "(j) 所有教学经验细节:",
        school: "学校",
        schoolfromMonth: "由年／月",
        schooltoMonth: "至年／月",
        classestaught: "任教班级",
        subjectstaught: "任教科目",
        publications: "(k) 任何曾发表的作品或原创研究的细节",
        subjectsTaught: "<b>3. 将任教科目</b>",
        subjectsTaughtError: "将任教科目",
        subjectsTaughtCon: "3. 将任教科目",
        proposedSalary: "<b>4. 拟付薪金</b>",
        proposedSalaryCon: "4. 拟付薪金",
        workingTime: "5. 全职或兼任",
        partTime: "（注明时数）",
        otherWorkingTime: "注明时数",
        regarding3:
            "6. 有关该教师的品格，可向以下人士查询，此等人士<b>{{fieldName}}</b>在此表格上填写的各项陈述:",
        regarding1: "6. 有关该教师的品格，可向以下人士查询，此等人士",
        regarding2: "在此表格上填写的各项陈述:---",
        name: "姓名",
        occupation: "职业",
        identityDocment: "身分证明文件",
        address: "地址",
        /* qualifications:
            "本人附交该教师的 ——（a）签名照片3张（b）健康检业证明书（c）学历证书或其他有关学历资格的证据。", */
        qualifications: {
            attach: "7. 本人附交该教师的 ——",
            a: "（a）签名照片3张",
            b: "（b）健康检查证明书",
            c: "（c）学历证书或其他有关学历资格的证据",
        },
        photograph: "照片",
        card: "身分证号码",
        president: "校长（签署）",
        approverEmailAddress: "电邮地址",
    },
};
export default Form015SC;
